import Keycloak from "keycloak-js";
//#region src/modules/core/data/keycloak.ts
var initKeycloak = async (keycloakConfig) => {
	const keycloak = new Keycloak(keycloakConfig);
	await keycloak.init({
		checkLoginIframe: false,
		onLoad: "check-sso"
	});
	return keycloak;
};
//#endregion
export { initKeycloak };
